import { ItemType, SkillEffectType } from '@game/enums';
import type { PopulatedItem } from '@game/game-data';
import { Paragraph, Skeleton } from '@game/ui';
import type { ReactNode } from 'react';

interface SkillsDescriptionProps {
  item: PopulatedItem;
  quality: number;
}

export const SkillsDescription = ({ item, quality }: SkillsDescriptionProps): ReactNode => {
  if (item.type !== ItemType.Equipment || !item.skillEffects || item.skillEffects.length === 0) {
    return null;
  }

  const validSkillEffects = item.skillEffects.filter(
    (skillEffect) => skillEffect.type === SkillEffectType.Passive && quality >= skillEffect.qualityMin && quality <= skillEffect.qualityMax,
  );

  if (validSkillEffects.length === 0) {
    return null;
  }

  return (
    <div className="examine-item--skill-effects">
      <Paragraph>Skill Effects:</Paragraph>
      {validSkillEffects.map((skillEffect) => {
        return (
          <div className="examine-item--skill-effects-skill" key={skillEffect.type}>
            <div style={{ display: 'inline-block', marginRight: '5px', verticalAlign: 'middle' }}>
              <Skeleton
                src={skillEffect.skill.imageUrl}
                width={25}
                height={25}
                style={{
                  borderRadius: '5px',
                  boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                }}
                alt={skillEffect.skill.name}
              />
            </div>
            <span>{skillEffect.skill.name}</span>
          </div>
        );
      })}
    </div>
  );
};
